<template>
  <div
    class="solfigrf-icm-hand-details solfigricmhdtls"
    :class="[{ gw_loading: loading }]"
  >
    <ExpandCard
      :opened="false"
      persistKey="solfigr_solfigricmhdtls"
      style="
        --clr-back-title: var(--clr-black-2);
        --clr-back-title-hover: var(--clr-black-2-3);
        --clr-back-title-active: var(--clr-black-2);
        --title-color: var(--clr-white-0);
        --content-padding: 0;
        --max-height: var(--vh-3);
        --radius: 4px;
        --radius-title: 4px 4px 0 0;
        --radius-content: 0 0 4px 4px;
        --open-overflow: unset;
        --overflow-content-open-y: unset;
        --overflow-content-open-x: unset;
      "
      data-tst="solfigr_solfigricmhdtls"
    >
      <template #title>
        <div
          class="flex-1 d-flex"
          style="min-width: 0"
        >
          <div
            class="mdi mr-2"
            :class="
              icmHandDetails && icmHandDetails.errors.total_errors
                ? 'mdi-close-circle clr-error'
                : 'mdi-check-circle clr-primary'
            "
            :data-tst="`icm_hand_details${icmHandDetails && icmHandDetails.errors.total_errors ? '_error' : '_ok'}`"
          ></div>
          {{ $t(`solfigr.icm.hand_details`) }}
        </div>
      </template>

      <div
        style="gap: 1rem; border: solid 2px var(--clr-black-2); border-top: none; padding: 0.5rem"
        class="f-column"
      >
        <div
          class="f-column"
          data-tst="pot_size"
        >
          <GwTitleTooltip
            :title="$t(`solfigr.icm.pot_size`)"
            :tooltip="$t(`solfigr.icm.pot_size_tooltip`)"
            style="margin: 0 0 0.25rem 0"
          />
          <NumberInput
            :min="conf.pot_size.min"
            :max="conf.pot_size.max"
            :step="conf.pot_size.step"
            :decimals="conf.pot_size.decimals"
            :inputmode="conf.pot_size.inputmode"
            :hasMinus="false"
            :hasPlus="false"
            :hasWheelScroll="false"
            style="--input-width: 6rem"
            :value="icmHandDetails.pot_size"
            @input="value => updateValue('pot_size', value)"
          />
        </div>

        <SolfigrPlayers
          class="solfigrtp_item"
          style="--player-table-size: 5.2rem"
          :loading
          :playerIP
          :playerOOP
          :playerOOP1
          @click:IP="$emit('click:IP')"
          @click:OOP="$emit('click:OOP')"
          @click:OOP+1="$emit('click:OOP+1')"
        />

        <SolfigrStacks
          :conf
          :hand-details="icmHandDetails"
          :has-bounty-instant
          :has-bounty-total
          :playerIP
          :playerOOP
          :playerOOP1
          @update:stack="stack => updateValue(stack.key, stack.value)"
        />
      </div>
    </ExpandCard>
  </div>
</template>

<script>
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import NumberInput from '@/components/lib/NumberInput'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import SolfigrPlayers from '@/components/ConfigureSolution/SolfigrPlayers'
import SolfigrStacks from '@/components/ConfigureSolution/SolfigrStacks.vue'
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'SolfigrIcmHandDetails',
  components: {
    ExpandCard,
    SolfigrPlayers,
    GwTitleTooltip,
    NumberInput,
    SolfigrStacks,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { String, required: true },
    loading: Boolean,
    playerIP: Object,
    playerOOP: Object,
    playerOOP1: Object,
    icmHandDetails: Object,
    bountyInstantPercentage: Number,
    hasBountyInstant: Boolean,
    hasBountyTotal: Boolean,
  },
  emits: ['update:icmHandDetails', 'click:IP', 'click:OOP', 'click:OOP+1'],
  data() {
    this.conf = getSolfigrFields()
    return {}
  },
  methods: {
    updateValue(key, value) {
      let payload = { ...this.icmHandDetails, [key]: value }
      if (['bounty_instant_IP', 'bounty_instant_OOP', 'bounty_instant_OOP1'].includes(key)) {
        const iKey = `bounty_total_${key.replace('bounty_instant_', '')}`
        payload = {
          ...payload,
          [iKey]: this.numFixed(value / this.bountyInstantPercentage, 2),
        }
        // debugger
      }
      if (['bounty_total_IP', 'bounty_total_OOP', 'bounty_total_OOP1'].includes(key)) {
        const iKey = `bounty_instant_${key.replace('bounty_total_', '')}`
        payload = {
          ...payload,
          [iKey]: this.numFixed(value * this.bountyInstantPercentage, 2),
        }
      }

      this.$emit('update:icmHandDetails', payload)
    },
  },
  isValid() {
    if (this.isPreflop)
      return this.conf.stack.preflop_stackAnteBlindCheck({
        stack: this.stack,
        ante: this.ante,
        preflop_SB: this.blind,
      })

    return this.conf.stack.flop_stackPotCheck({
      stack: this.stack,
      pot: this.pot,
    })
  },
}
</script>
